module.exports = __webpack_public_path__ + "img/icon-round-instagram.2b54af68.svg";